import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "api/baseurl";
import { toast } from "react-toastify";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import { IconButton } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import DescriptionIcon from "@mui/icons-material/Description";
import ComplianceIcon from "@mui/icons-material/VerifiedUser"; 
import BadgeIcon from '@mui/icons-material/Badge';

import "react-toastify/dist/ReactToastify.css";
import {
  Grid,
  Box,
  Typography,
  Card,
  Autocomplete,
  TextField,
} from "@mui/material";
import { keyframes } from "@mui/system";
import { Country, State, City } from "country-state-city";

import MDButton from "components/MDButton";
import MDBox from "components/MDBox";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDInput from "components/MDInput";

import { encryptBody } from "encryptionAndDecryption/bodyEncryption";
import { decryptBody } from "encryptionAndDecryption/bodyDecryption";
import { fetchSecretKey } from "encryptionAndDecryption/secretKeyDecryption";
import { formatDateDDMMYYYY } from "utils/dateFormatter";
import "../styles/form-labels.css";
import MedicalAbstractBackground from "./MedicalAbstractBackground ";

// Dummy Custom Stepper Component
const SectionHeader = ({ title }) => (
  <Box my={3}>
    <Typography
      variant="h6"
      sx={{ fontWeight: "bold", color: "#2e7fae", borderBottom: "2px solid #2e7fae" }}
    >
      {title}
    </Typography>
  </Box>
);

function AddHospitalData() {

      const date = new Date();
  let day = date.getDate().toString().padStart(2, "0");
  let month = (date.getMonth() + 1).toString().padStart(2, "0");
  let year = date.getFullYear();
  let currentDate = `${year}-${month}-${day}`;
  const getCurrentDate = () => {
    const today = new Date();
    const yyyy = today.getFullYear();
    const mm = String(today.getMonth() + 1).padStart(2, "0");
    const dd = String(today.getDate()).padStart(2, "0");
    return `${yyyy}-${mm}-${dd}`;
  };
  const loginData = JSON.parse(localStorage.getItem("loginData"));
  const userid = loginData?.userid;
  const role = loginData?.role;
  console.log("Role:", role);
  const navigate = useNavigate();
const [errors, setErrors] = useState({});

  const [loading, setLoading] = useState(false);

  // Dropdown data
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [showDocuments, setShowDocuments] = useState(false);
const [formErrors, setFormErrors] = useState({
  hospitalId: "",
  hospitalCode: "",
  hospitalName: "",
  addressLine1: "",
  addressLine2: "",
  city: "",
  state: "",
  pincode: "",
  country: "",
  phoneNumber: "",
  emergencyphoneNumber: "",
  email: "",
  website: "",
  gstno: "",
  registrationAuthority: "",
  registrationNumber: "",
  directorName: "",
  ownershipType: "",
  hospitalType: "",
  
  establishmentYear: "",
  mcaCin: "",
  document: [
    {
      documentname: "",
      documenttype: "",
      dateofupload: getCurrentDate(),
      imageMeta: "",
      image: "",
    },
  ],
});

  // Mapping details → Hospital profile
  const [mappingDetails, setMappingDetails] = useState({
    hospitalId: "",
    hospitalCode: "",
    hospitalName: "",
    addressLine1: "",
    addressLine2: "",
    city: "",
    state: "",
    pincode: "",
    country: "",
phoneCountryCode: "+91",
emergencyCountryCode: "+91",
    phoneNumber: "",
    emergencyphoneNumber: "",
    email: "",
    website: "",
    gstno:"",
    registrationAuthority:"",
    registrationNumber:"",
    directorName:"",
    ownershipType:"",
    hospitalType:"",
    
    establishmentYear:"",
    mcaCin:"",
     document:[
     {
      documentname: "",
      documenttype: "",
      dateofupload: getCurrentDate(),
      imageMeta: "",
      image: "",
    },
    ],
  });
 const countryCodes = [
  { code: "+91", name: "India" },
  { code: "+1", name: "USA" },
  { code: "+44", name: "UK" },
  { code: "+61", name: "Australia" },
  { code: "+971", name: "UAE" },
];
const countryPhoneRules = {
  "+91": 10, // India
  "+1": 10,  // USA / Canada
  "+44": 10, // UK
  "+61": 9,  // Australia
  "+971": 9, // UAE
};
const countryPhonePatterns = {
  "+91": /^[6-9]\d{9}$/, // India: must start with 6–9 and be 10 digits
  "+1": /^[2-9]\d{9}$/,  // USA: first digit cannot be 0 or 1
  "+44": /^\d{10}$/,     // UK: 10 digits
  "+61": /^\d{9}$/,      // Australia: 9 digits
  "+971": /^\d{9}$/,     // UAE: 9 digits
};
  // 🔹 Load countries on mount
  useEffect(() => {
    setCountries(Country.getAllCountries());
  }, []);

  // 🔹 Country change
  const handleCountryChange = (countryObj) => {
    setMappingDetails((prev) => ({
      ...prev,
      country: countryObj?.isoCode || "",
      state: "",
      city: "",
    }));
    if (countryObj) {
      setStates(State.getStatesOfCountry(countryObj.isoCode));
    } else {
      setStates([]);
    }
    setDistricts([]);
  };

  // 🔹 State change
  const handleStateChange = (stateObj) => {
    setMappingDetails((prev) => ({
      ...prev,
      state: stateObj?.isoCode || "",
      city: "",
    }));
    if (stateObj && mappingDetails.country) {
      setDistricts(City.getCitiesOfState(mappingDetails.country, stateObj.isoCode));
    } else {
      setDistricts([]);
    }
  };

  // 🔹 City change
  const handleCityChange = (cityObj) => {
    setMappingDetails((prev) => ({
      ...prev,
      city: cityObj?.name || "",
    }));
  };
const validateHospitalForm = () => {
  const errors = { ...formErrors }; // copy previous errors

  // Clear previous errors
  Object.keys(errors).forEach(key => {
    if (key !== "document") errors[key] = "";
  });
  errors.document = errors.document.map(() => ({
    documentname: "",
    documenttype: "",
      dateofupload: getCurrentDate(),
    imageMeta: "",
    image: "",
  }));

const phoneCode = mappingDetails.phoneCountryCode;
const emergencyCode = mappingDetails.emergencyCountryCode;
  const phoneNumber = mappingDetails.phoneNumber?.trim() || "";
    const emergencyphoneNumber = mappingDetails.emergencyphoneNumber?.trim() || "";

  const countryPhonePatterns = {
    "+91": /^[6-9]\d{9}$/, // India
    "+1": /^[2-9]\d{9}$/,  // USA
    "+44": /^\d{10}$/,     // UK
    "+61": /^\d{9}$/       // Australia
  };

  const countryPhoneRules = {
    "+91": 10,
    "+1": 10,
    "+44": 10,
    "+61": 9
  };

  const expectedLength = countryPhoneRules[phoneCode] || 10;
  const pattern = countryPhonePatterns[phoneCode];
  if (!phoneNumber) {
    errors.phoneNumber = "Phone number is required";
  } else if (!/^\d+$/.test(phoneNumber)) {
    errors.phoneNumber = "Phone number must contain only digits";
  } else if (phoneNumber.length !== expectedLength) {
    errors.phoneNumber = `Invalid phone number length for ${phoneCode}. Expected ${expectedLength} digits.`;
  } else if (pattern && !pattern.test(phoneNumber)) {
    errors.phoneNumber = `Invalid phone number format for ${phoneCode}`;
  } else if (!pattern && (phoneNumber.length < 6 || phoneNumber.length > 15)) {
    errors.phoneNumber = `Invalid phone number format for ${phoneCode}`;
  }
  const expectedLengthEmergency = countryPhoneRules[emergencyCode] || 10;
const patternEmergency = countryPhonePatterns[emergencyCode];
   if (!emergencyphoneNumber) {
    errors.emergencyphoneNumber = " Emergency Phone number is required";
  } else if (!/^\d+$/.test(emergencyphoneNumber)) {
    errors.emergencyphoneNumber = " Emergency Phone number must contain only digits";
  } else if (emergencyphoneNumber.length !== expectedLengthEmergency) {
    errors.emergencyphoneNumber = `Invalid Emergency phone number length for ${emergencyCode}. Expected ${expectedLengthEmergency} digits.`;
  } else if (patternEmergency && !patternEmergency.test(emergencyphoneNumber)) {
    errors.emergencyphoneNumber = `Invalid  Emergency phone number format for ${emergencyCode}`;
  } else if (!patternEmergency && (emergencyphoneNumber.length < 6 || emergencyphoneNumber.length > 15)) {
    errors.emergencyphoneNumber = `Invalid  Emergency phone number format for ${emergencyCode}`;
  }

  // ✅ Country code validation
 if (!mappingDetails.phoneCountryCode || mappingDetails.phoneCountryCode.trim() === "") {
  errors.phoneCountryCode = "Country code is required";
}
if (!mappingDetails.emergencyCountryCode || mappingDetails.emergencyCountryCode.trim() === "") {
  errors.emergencyCountryCode = "Country code is required";
}

  // Field validations
  if (!mappingDetails.hospitalId?.trim()) errors.hospitalId = "Hospital ID is required";
if (!mappingDetails.hospitalCode?.trim()) {
  errors.hospitalCode = "Hospital Code is required";
} else if (!/^[a-zA-Z0-9]+$/.test(mappingDetails.hospitalCode)) {
  errors.hospitalCode = "Hospital Code must contain only letters and numbers";
}


  if (!mappingDetails.hospitalName?.trim()) errors.hospitalName = "Hospital Name is required";
  if (!mappingDetails.addressLine1?.trim()) errors.addressLine1 = "Address Line 1 is required";
  if (!mappingDetails.city?.trim()) errors.city = "City is required";
  if (!mappingDetails.state?.trim()) errors.state = "State is required";
  if (!mappingDetails.country?.trim()) errors.country = "Country is required";
  if (!mappingDetails.pincode?.trim()) errors.pincode = "Postal Code is required";
  // if (!mappingDetails.phoneNumber?.trim()) errors.phoneNumber = "Phone Number is required";
// Establishment Year
if (!mappingDetails.mcaCin || mappingDetails.mcaCin.trim() === "") {
  errors.mcaCin = "MCA CIN is required";
} 
else if (!/^[A-Za-z0-9]{21}$/.test(mappingDetails.mcaCin)) {
  errors.mcaCin = "MCA CIN must be 21 alphanumeric characters";
}

const currentYear = new Date().getFullYear();

if (mappingDetails.establishmentYear) {
  const year = mappingDetails.establishmentYear;

  // Check if it's exactly 4 digits
  if (!/^\d{4}$/.test(year)) {
    errors.establishmentYear = "Establishment Year must be exactly 4 digits";
  } 
  else if (parseInt(year, 10) > currentYear) {
    errors.establishmentYear = `Establishment Year cannot be in the future (max ${currentYear})`;
  }
}
if (!mappingDetails.registrationNumber || mappingDetails.registrationNumber.trim() === "") {
  errors.registrationNumber = "Registration Number is required";
} 
else if (!/^[A-Za-z0-9\-\/]+$/.test(mappingDetails.registrationNumber)) {
  errors.registrationNumber = "Registration Number can only contain letters, numbers, '-' or '/'";
} 
else if (mappingDetails.registrationNumber.length < 4 || mappingDetails.registrationNumber.length > 20) {
  errors.registrationNumber = "Registration Number must be between 4 and 20 characters";
}
// Website
if (mappingDetails.website && !/^(https?:\/\/)([\w\-]+\.)+[\w\-]+(\/[\w\-._~:/?#[\]@!$&'()*+,;=]*)?$/i.test(mappingDetails.website)) {
  errors.website = "Enter a valid website URL (must start with http or https)";
}

  if (!mappingDetails.email?.trim()) {
    errors.email = "Email is required";
  } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(mappingDetails.email)) {
    errors.email = "Invalid email format";
  }

  // Document validation
  // mappingDetails.document.forEach((doc, index) => {
  //   if (!doc.documentname?.trim()) errors.document[index].documentname = "Document Name is required";
  //   if (!doc.documenttype?.trim()) errors.document[index].documenttype = "Document Type is required";
  //   if (!doc.image) errors.document[index].image = "Document file is required";
  // });

  setFormErrors(errors);

  // Return true if no errors
  return (
    Object.values(errors).filter(e => typeof e === "string" && e).length === 0 &&
    errors.document.every(doc => !doc.documentname && !doc.documenttype && !doc.image)
  );
};


  // 🔹 Submit
  const handleSubmit = async (e) => {
    e.preventDefault();

      const isValid = validateHospitalForm();
  if (!isValid) {
    toast.error("Please fix the errors highlighted in red.");
    return; // stop API call
  }


    setLoading(true);
    try {
      const secretKey = await fetchSecretKey();
      const token = JSON.parse(localStorage.getItem("loginData"))?.token;

    // Prepare hospital payload (without documents)
    const hospitalPayload = {

       ccid: role === "ROLE_SUPER" ? "" : userid,
      hospitalId: mappingDetails.hospitalId,
      hospitalCode: mappingDetails.hospitalCode,
      hospitalName: mappingDetails.hospitalName,
      addressLine1: mappingDetails.addressLine1,
      addressLine2: mappingDetails.addressLine2,
      city: mappingDetails.city,
      state: mappingDetails.state,
      pincode: mappingDetails.pincode,
      country: mappingDetails.country,
     phoneNumber: `${mappingDetails.phoneNumber}`,
emergencyphoneNumber: `${mappingDetails.emergencyphoneNumber}`,
phonecountrycode:`${mappingDetails.phoneCountryCode}`,
emergencycountrycode:`${mappingDetails.emergencyCountryCode}`,

      email: mappingDetails.email,
      website: mappingDetails.website,
      gstno: mappingDetails.gstno,
      registrationAuthority: mappingDetails.registrationAuthority,
      registrationNumber: mappingDetails.registrationNumber,
      directorName: mappingDetails.directorName,
      ownershipType: mappingDetails.ownershipType,
      hospitalType: mappingDetails.hospitalType,
      establishmentYear: mappingDetails.establishmentYear,
      mcaCin: mappingDetails.mcaCin,
    };

    // Prepare documents separately
    const documentsPayload = mappingDetails.document
  .filter(doc => doc.documentname || doc.documenttype || doc.image) // only include non-empty
  .map(doc => ({
    documentname: doc.documentname,
    documenttype: doc.documenttype,
   dateofupload: formatDateDDMMYYYY(doc.dateofupload ? doc.dateofupload : currentDate),
    imageMeta: doc.imageMeta,
    image: doc.image,
  }));

    // Full payload
    const rawPayload = {
         username: mappingDetails.email,
        role: "ROLE_HOSPITAL",

      hospital: hospitalPayload,
      document: documentsPayload,
    };

    const encryptedData = encryptBody(rawPayload, secretKey);
      const response = await axios.post(
        "/api/HospitalProfile/register",
        encryptedData,
        {

          
          headers: {
            "Content-Type": "text/plain",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status === 200) {
        const decrypted = decryptBody(response.data, secretKey);
        toast.success(decrypted?.message || "Hospital Profile Created!");
        navigate(-1);
      }
    } catch (error) {
  console.error("Registration Error:", error);

  let errorMessage = "Registration failed"; // default message

  if (error.response) {
    const data = error.response.data;

    // ✅ If backend sends a structured JSON with a 'message' field
    if (typeof data === "object" && data.message) {
      errorMessage = data.message;
    } 
    // ✅ If backend sends a plain text message
    else if (typeof data === "string") {
      errorMessage = data;
    }
  } 
  // ✅ For network or other unexpected errors
  else if (error.message) {
    errorMessage = error.message;
  }

  toast.error(errorMessage);
} finally {
  setLoading(false);
}
  };

  // Spinner animation
  const spinAnimation = keyframes`
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  `;
 const handleAddDocument = () => {
  setMappingDetails((prev) => ({
    ...prev,
    document: [
      ...prev.document,
      {
        documentname: "",
        documenttype: "",
      dateofupload: getCurrentDate(),
        imageMeta: "",
        image: "",
      },
    ],
  }));
};
  return (
    <DashboardLayout>
      <DashboardNavbar />
     <MedicalAbstractBackground/>
      
      {loading && (
        <Box
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "rgba(255, 255, 255, 0.8)",
            zIndex: 9999,
          }}
        >
          <Box
            sx={{
              position: "relative",
              width: 80,
              height: 80,
              animation: `${spinAnimation} 1.5s linear infinite`,
            }}
          >
            {[...Array(8)].map((_, index) => (
              <Box
                key={index}
                sx={{
                  width: 8,
                  height: 8,
                  borderRadius: "50%",
                  backgroundColor: "#1A237E",
                  position: "absolute",
                }}
              />
            ))}
          </Box>
        </Box>
      )}

      <Card sx={{ width: "1000px", padding: 3, margin: "auto" }}>
        <MDBox pt={4} pb={3} px={3}>
          <form onSubmit={handleSubmit}>
            {/* Core Identification */}
<SectionHeader
  title={
<Box
      display="flex"
      alignItems="center"
      gap={1}
      sx={{ color: "#3949AB", fontWeight: 600 }} // Added color here
    >
      <BadgeIcon fontSize="small" />
      <span>Core Identification</span>
    </Box>
  }
/>            <Grid container spacing={2}>
              <Grid item xs={4}>
                <TextField
                  fullWidth
                  label="Hospital ID"
                  value={mappingDetails.hospitalId}
        onChange={(e) =>
                    setMappingDetails((prev) => ({
                      ...prev,
                      hospitalId: e.target.value,
                    }))
                  }
                />
                {formErrors.hospitalId && (
  <Typography sx={{ color: "red", fontSize: "12px", mt: 0.5 }}>
    {formErrors.hospitalId}
  </Typography>
)}
              </Grid>

             <Grid item xs={4}>
  <TextField
    fullWidth
    label="Hospital Code"
    value={mappingDetails.hospitalCode}
    onChange={(e) => {
      const value = e.target.value.replace(/\D/g, ""); // remove non-digits
      setMappingDetails((prev) => ({
        ...prev,
        hospitalCode: value,
      }));
    }}
  />
  {formErrors.hospitalCode && (
    <Typography sx={{ color: "red", fontSize: "12px", mt: 0.5 }}>
      {formErrors.hospitalCode}
    </Typography>
  )}
</Grid>


              <Grid item xs={4}>
                <TextField
                  fullWidth
                  label="Hospital Name"
                  value={mappingDetails.hospitalName}
                  onChange={(e) =>
                    setMappingDetails((prev) => ({
                      ...prev,
                      hospitalName: e.target.value,
                    }))
                  }
                />
                 {formErrors.hospitalName && (
  <Typography sx={{ color: "red", fontSize: "12px", mt: 0.5 }}>
    {formErrors.hospitalName}
  </Typography>
)}
              </Grid>
            </Grid>

            {/* Location & Contact Info */}
<SectionHeader 
  title={
<Box
      display="flex"
      alignItems="center"
      gap={1}
      sx={{ color: "#3949AB", fontWeight: 600 }} // Added color here
    >
      <LocationOnIcon /> Location & Contact Info
    </Box>
  }
/>            <Grid container spacing={2}>
              <Grid item xs={6}>
                <TextField
                  fullWidth
                  label="Address Line 1"
                  value={mappingDetails.addressLine1}
                  onChange={(e) =>
                    setMappingDetails((prev) => ({
                      ...prev,
                      addressLine1: e.target.value,
                    }))
                  }
                />
                 {formErrors.addressLine1 && (
  <Typography sx={{ color: "red", fontSize: "12px", mt: 0.5 }}>
    {formErrors.addressLine1}
  </Typography>
)}
              </Grid>

              <Grid item xs={6}>
                <TextField
                  fullWidth
                  label="Address Line 2"
                  value={mappingDetails.addressLine2}
                  onChange={(e) =>
                    setMappingDetails((prev) => ({
                      ...prev,
                      addressLine2: e.target.value,
                    }))
                  }
                />
              </Grid>

              <Grid item xs={4}>
                <Autocomplete
                  options={countries}
                  getOptionLabel={(option) => option.name}
                  value={
                    countries.find((c) => c.isoCode === mappingDetails.country) ||
                    null
                  }
                  onChange={(e, value) => handleCountryChange(value)}
                  renderInput={(params) => (
                    <TextField {...params} label="Country" fullWidth />
                  )}
                />
                 {formErrors.country && (
  <Typography sx={{ color: "red", fontSize: "12px", mt: 0.5 }}>
    {formErrors.country}
  </Typography>
)}
              </Grid>

              <Grid item xs={4}>
                <Autocomplete
                  options={states}
                  getOptionLabel={(option) => option.name}
                  value={
                    states.find((s) => s.isoCode === mappingDetails.state) || null
                  }
                  onChange={(e, value) => handleStateChange(value)}
                  renderInput={(params) => (
                    <TextField {...params} label="State / Province" fullWidth />
                  )}
                />
                 {formErrors.state && (
  <Typography sx={{ color: "red", fontSize: "12px", mt: 0.5 }}>
    {formErrors.state}
  </Typography>
)}
              </Grid>

              <Grid item xs={4}>
                <Autocomplete
                  options={districts}
                  getOptionLabel={(option) => option.name}
                  value={
                    districts.find((c) => c.name === mappingDetails.city) || null
                  }
                  onChange={(e, value) => handleCityChange(value)}
                  renderInput={(params) => (
                    <TextField {...params} label="City" fullWidth />
                  )}
                />
                 {formErrors.city && (
  <Typography sx={{ color: "red", fontSize: "12px", mt: 0.5 }}>
    {formErrors.city}
  </Typography>
)}
              </Grid>

              <Grid item xs={6}>
                <TextField
                  fullWidth
                  label="Postal Code / Zip"
                  value={mappingDetails.pincode}
                  onChange={(e) =>
                    setMappingDetails((prev) => ({
                      ...prev,
                      pincode: e.target.value,
                    }))
                  }
                />
                 {formErrors.pincode && (
  <Typography sx={{ color: "red", fontSize: "12px", mt: 0.5 }}>
    {formErrors.pincode}
  </Typography>
)}
              </Grid>
<Grid item xs={6}>
  <Grid container spacing={1}>
    {/* Phone Number */}
    <Grid item xs={4}>
      <MDInput
        select
        label="Country Code"
        fullWidth
        value={mappingDetails.phoneCountryCode || "+91"}
        onChange={(e) =>
          setMappingDetails({
            ...mappingDetails,
            phoneCountryCode: e.target.value,
          })
        }
        sx={{
          "& .MuiInputBase-root": {
            height: "45px",
          },
        }}
      >
        {countryCodes.map((item) => (
          <MenuItem key={item.code} value={item.code}>
            {`${item.name} (${item.code})`}
          </MenuItem>
        ))}
      </MDInput>
    </Grid>

    <Grid item xs={8}>
      <TextField
        fullWidth
        label="Phone Number"
        value={mappingDetails.phoneNumber}
        onChange={(e) => {
          const code = mappingDetails.phoneCountryCode || "+91";
          const maxLength = countryPhoneRules[code] || 10;
          const value = e.target.value.replace(/\D/g, ""); // only digits
          if (value.length <= maxLength) {
            setMappingDetails({
              ...mappingDetails,
              phoneNumber: value,
            });
          }
        }}
        onBlur={() => {
          const phone = mappingDetails.phoneNumber || "";
          const code = mappingDetails.phoneCountryCode || "+91";
          const expectedLength = countryPhoneRules[code] || 10;
          const pattern = countryPhonePatterns[code];

          if (phone.length !== expectedLength) {
            setFormErrors((prev) => ({
              ...prev,
              phoneNumber: `Phone number must be exactly ${expectedLength} digits for ${code}`,
            }));
          } else if (!pattern.test(phone)) {
            setFormErrors((prev) => ({
              ...prev,
              phoneNumber: `Invalid phone number format for ${code}`,
            }));
          } else {
            setFormErrors((prev) => ({ ...prev, phoneNumber: "" }));
          }
        }}
      />
    </Grid>
  </Grid>

  {/* Error Message */}
  {formErrors.phoneNumber ? (
    <Typography sx={{ color: "red", fontSize: "12px", mt: 0.5 }}>
      {formErrors.phoneNumber}
    </Typography>
  ) : (
    <Typography sx={{ fontSize: "12px", color: "gray", mt: 0.5 }}>
      {mappingDetails.phoneCountryCode === "+91"
        ? "Enter a 10-digit Indian number (e.g., 9876543210)"
        : `Enter ${
            countryPhoneRules[mappingDetails.phoneCountryCode || "+91"]
          } digits phone number for ${
            countryCodes.find(
              (c) => c.code === mappingDetails.phoneCountryCode
            )?.name || "selected country"
          }`}
    </Typography>
  )}
</Grid>

<Grid item xs={6}>
  <Grid container spacing={1}>
    {/* Emergency Phone Number */}
    <Grid item xs={4}>
      <MDInput
        select
        label="Country Code"
        fullWidth
        value={mappingDetails.emergencyCountryCode || "+91"}
        onChange={(e) =>
          setMappingDetails({
            ...mappingDetails,
            emergencyCountryCode: e.target.value,
          })
        }
        sx={{
          "& .MuiInputBase-root": {
            height: "45px",
          },
        }}
      >
        {countryCodes.map((item) => (
          <MenuItem key={item.code} value={item.code}>
            {`${item.name} (${item.code})`}
          </MenuItem>
        ))}
      </MDInput>
    </Grid>

    <Grid item xs={8}>
      <TextField
        fullWidth
        label="Emergency Number"
        value={mappingDetails.emergencyphoneNumber}
        onChange={(e) => {
          const code = mappingDetails.emergencyCountryCode || "+91";
          const maxLength = countryPhoneRules[code] || 10;
          const value = e.target.value.replace(/\D/g, "");
          if (value.length <= maxLength) {
            setMappingDetails({
              ...mappingDetails,
              emergencyphoneNumber: value,
            });
          }
        }}
        onBlur={() => {
          const phone = mappingDetails.emergencyphoneNumber || "";
          const code = mappingDetails.emergencyCountryCode || "+91";
          const expectedLength = countryPhoneRules[code] || 10;
          const pattern = countryPhonePatterns[code];

          if (phone.length !== expectedLength) {
            setFormErrors((prev) => ({
              ...prev,
              emergencyphoneNumber: `Phone number must be exactly ${expectedLength} digits for ${code}`,
            }));
          } else if (!pattern.test(phone)) {
            setFormErrors((prev) => ({
              ...prev,
              emergencyphoneNumber: `Invalid phone number format for ${code}`,
            }));
          } else {
            setFormErrors((prev) => ({ ...prev, emergencyphoneNumber: "" }));
          }
        }}
      />
    </Grid>
  </Grid>

  {/* Error Message */}
  {formErrors.emergencyphoneNumber ? (
    <Typography sx={{ color: "red", fontSize: "12px", mt: 0.5 }}>
      {formErrors.emergencyphoneNumber}
    </Typography>
  ) : (
    <Typography sx={{ fontSize: "12px", color: "gray", mt: 0.5 }}>
      {mappingDetails.emergencyCountryCode === "+91"
        ? "Enter a 10-digit Indian number (e.g., 9876543210)"
        : `Enter ${
            countryPhoneRules[mappingDetails.emergencyCountryCode || "+91"]
          } digits phone number for ${
            countryCodes.find(
              (c) => c.code === mappingDetails.emergencyCountryCode
            )?.name || "selected country"
          }`}
    </Typography>
  )}
</Grid>



              <Grid item xs={6}>
                <TextField
                  fullWidth
                  label="Email"
                  value={mappingDetails.email}
                  onChange={(e) =>
                    setMappingDetails((prev) => ({
                      ...prev,
                      email: e.target.value,
                    }))
                  }
                />
                 {formErrors.email && (
  <Typography sx={{ color: "red", fontSize: "12px", mt: 0.5 }}>
    {formErrors.email}
  </Typography>
)}
              </Grid>

              <Grid item xs={12}>
               <TextField
  fullWidth
  label="Website"
  value={mappingDetails.website}
  onChange={(e) =>
    setMappingDetails((prev) => ({
      ...prev,
      website: e.target.value,
    }))
  }
  onBlur={() => {
    const website = mappingDetails.website.trim();
    const urlRegex = /^(https?:\/\/)([\w\-]+\.)+[\w\-]+(\/[\w\-._~:/?#[\]@!$&'()*+,;=]*)?$/i;
    if (website && !urlRegex.test(website)) {
      setFormErrors((prev) => ({
        ...prev,
        website: "Enter a valid website URL (must start with http or https)",
      }));
    } else {
      setFormErrors((prev) => ({ ...prev, website: "" }));
    }
  }}
/>
{formErrors.website && (
  <Typography sx={{ color: "red", fontSize: "12px", mt: 0.5 }}>
    {formErrors.website}
  </Typography>
)}

              </Grid>
<SectionHeader 
  title={
   <Box
      display="flex"
      alignItems="center"
      gap={1}
      sx={{ color: "#3949AB", fontWeight: 600 }} // Added color here
    >

      <ComplianceIcon /> Regulatory & Compliance
    </Box>
  }
/><Grid container spacing={2}>

              <Grid item xs={6}>
  <TextField
    fullWidth
    label="GST Number"
    value={mappingDetails.gstno}
    onChange={(e) =>
      setMappingDetails((prev) => ({
        ...prev,
        gstno: e.target.value,
      }))
    }
  />
</Grid>

              <Grid item xs={6}>
  <TextField
    fullWidth
    label="Registration Authority"
    value={mappingDetails.registrationAuthority}
    onChange={(e) =>
      setMappingDetails((prev) => ({
        ...prev,
        registrationAuthority: e.target.value,
      }))
    }
  />
</Grid>

              <Grid item xs={6}>
  <TextField
    fullWidth
    label="Registration Number"
    value={mappingDetails.registrationNumber}
    onChange={(e) =>
      setMappingDetails((prev) => ({
        ...prev,
        registrationNumber: e.target.value,
      }))
    }
  />
  {formErrors.registrationNumber && (
  <Typography sx={{ color: "red", fontSize: "12px", mt: 0.5 }}>
    {formErrors.registrationNumber}
  </Typography>
)}
</Grid>

              <Grid item xs={6}>
  <TextField
    fullWidth
    label="Director Name"
    value={mappingDetails.directorName}
    onChange={(e) =>
      setMappingDetails((prev) => ({
        ...prev,
        directorName: e.target.value,
      }))
    }
  />
</Grid>

               <Grid item xs={6}>
    <TextField
      select
      label="Ownership Type"
      fullWidth
      value={mappingDetails.ownershipType}
      onChange={(e) =>
        setMappingDetails((prev) => ({
          ...prev,
          ownershipType: e.target.value,
        }))
      }
      sx={{
        "& .MuiInputBase-root": {
          height: 45, // height of the input
        },
        "& .MuiSelect-select": {
          display: "flex",
          alignItems: "center", // vertically center text
          paddingTop: 0,
          paddingBottom: 0,
        },
      }}
    >
      <MenuItem value="Private">Private</MenuItem>
      <MenuItem value="Government">Government</MenuItem>
      <MenuItem value="Trust">Trust</MenuItem>
      <MenuItem value="Corporate">Corporate</MenuItem>
    </TextField>
  </Grid>

  {/* Hospital Type */}
  <Grid item xs={6}>
    <TextField
      select
      label="Hospital Type"
      fullWidth
      value={mappingDetails.hospitalType}
      onChange={(e) =>
        setMappingDetails((prev) => ({
          ...prev,
          hospitalType: e.target.value,
        }))
      }
      sx={{
        "& .MuiInputBase-root": {
          height: 45,
        },
        "& .MuiSelect-select": {
          display: "flex",
          alignItems: "center",
          paddingTop: 0,
          paddingBottom: 0,
        },
      }}
    >
      <MenuItem value="Multispecialty">Multispecialty</MenuItem>
      <MenuItem value="Super-specialty">Super-specialty</MenuItem>
      <MenuItem value="Clinic">Clinic</MenuItem>
      <MenuItem value="Nursing Home">Nursing Home</MenuItem>
      <MenuItem value="Diagnostic Center">Diagnostic Center</MenuItem>
    </TextField>
  </Grid>

          <Grid item xs={4}>
  <TextField
    fullWidth
    label="Establishment Year"
    value={mappingDetails.establishmentYear}
    onChange={(e) => {
      const value = e.target.value.replace(/\D/g, ""); // only digits
      if (value.length <= 4) {
        setMappingDetails((prev) => ({
          ...prev,
          establishmentYear: value,
        }));
      }
    }}
    onBlur={() => {
      const year = mappingDetails.establishmentYear;
      const currentYear = new Date().getFullYear();

      let error = "";
      if (!year) {
        error = "Establishment year is required";
      } else if (year.length !== 4) {
        error = "Year must be exactly 4 digits";
      } else if (parseInt(year) > currentYear) {
        error = `Year cannot be greater than ${currentYear}`;
      }

      setFormErrors((prev) => ({
        ...prev,
        establishmentYear: error,
      }));
    }}
    inputProps={{ maxLength: 4 }}
  />

  {/* Display error below field without red border */}
  {formErrors.establishmentYear && (
    <Typography sx={{ color: "red", fontSize: "12px", mt: 0.5 }}>
      {formErrors.establishmentYear}
    </Typography>
  )}
</Grid>



              <Grid item xs={4}>
  <TextField
    fullWidth
    label="MCA CIN"
    value={mappingDetails.mcaCin}
    onChange={(e) =>
      setMappingDetails((prev) => ({
        ...prev,
        mcaCin: e.target.value,
      }))
    }
  />
  {formErrors.mcaCin && (
  <Typography sx={{ color: "red", fontSize: "12px", mt: 0.5 }}>
    {formErrors.mcaCin}
  </Typography>
)}
</Grid>

   <Grid item xs={12}>
  <Box mt={2}>
    <a
      href="https://www.mca.gov.in/"
      target="_blank"
      rel="noopener noreferrer"
      style={{
        fontSize: "1rem",
        color: "#1e6a91",
        textDecoration: "underline",
      }}
    >
      Verify Hospital Documents
    </a>
  </Box>
</Grid>
 </Grid>
<SectionHeader 
  title={
<Box
      display="flex"
      alignItems="center"
      gap={1}
      sx={{ color: "#3949AB", fontWeight: 600 }} // Added color here
    >
      <DescriptionIcon /> Documents Upload
    </Box>
  }
/><Grid container spacing={2}>
{/* <Grid item xs={12}>
  <MDButton
    variant="outlined"
    onClick={() => setShowDocuments(!showDocuments)}
    sx={{
      background: "#2e7faeff",
      color: "#fff",
      "&:hover": { background: "#1e6a91" },
      mt: 1,
    }}
  >
    {showDocuments ? "Hide Documents" : "Add Documents"}
  </MDButton>
</Grid> */}
  </Grid>

{ mappingDetails?.document.map((doc, index) => (
  <Grid container spacing={2} key={index} mt={1}>
     <Grid item xs={6}>
    <TextField
      select
      label="Document Name"
      fullWidth
      value={doc.documentname}
      onChange={(e) => {
        const updatedDocs = [...mappingDetails.document];
        updatedDocs[index].documentname = e.target.value;

        // If Aadhaar is selected, reset verification status
        if (e.target.value === "Aadhar Card") {
          updatedDocs[index].verified = false;
        } else {
          updatedDocs[index].verified = true; // No need verification
        }

        setMappingDetails({ ...mappingDetails, document: updatedDocs });
      }}
       sx={{
      "& .MuiInputBase-root": {
        height: "45px",  
      },
    }}
    >
     <MenuItem value="Hospital Registration Certificate">Hospital Registration Certificate</MenuItem>
    <MenuItem value="Clinical Establishment License">Clinical Establishment License</MenuItem>
    <MenuItem value="No Objection Certificate (NOC)">No Objection Certificate (NOC)</MenuItem>
    <MenuItem value="PAN Card">PAN Card</MenuItem>
    <MenuItem value="Aadhar Card / Passport / Driving License">Aadhar Card / Passport / Driving License</MenuItem>
    <MenuItem value="Board Resolution">Board Resolution</MenuItem>
    <MenuItem value="Building Safety Certificate">Building Safety Certificate</MenuItem>
    <MenuItem value="Fire Safety Certificate">Fire Safety Certificate</MenuItem>
    
    <MenuItem value="Affiliation Certificates">Affiliation Certificates</MenuItem>
    <MenuItem value="Insurance Documents">Insurance Documents</MenuItem>
    </TextField>
  </Grid>
   {/* Document Type */}
  {/* <Grid item xs={6}>
  <TextField
    select
    label="Document Type"
    fullWidth
    value={doc.documenttype}
    onChange={(e) => {
      const updatedDocs = [...mappingDetails.document];
      updatedDocs[index].documenttype = e.target.value;
      setMappingDetails({ ...mappingDetails, document: updatedDocs });
    }}
    sx={{
      "& .MuiInputBase-root": {
        height: "45px",
      },
    }}
  >
    <MenuItem value="PDF">PDF</MenuItem>
    <MenuItem value="Image">Image (JPG, PNG)</MenuItem>
    <MenuItem value="Word Document">Word Document (DOC, DOCX)</MenuItem>
    <MenuItem value="Other">Other</MenuItem>
  </TextField>
</Grid> */}

  {/* Date of Upload */}
  {/* <Grid item xs={6}>
    <MDInput
      type="date"
      label="Date of Upload"
      fullWidth
      InputLabelProps={{ shrink: true }}
      value={doc.dateofupload}
      onChange={(e) => {
        const updatedDocs = [...mappingDetails.document];
        updatedDocs[index].dateofupload = e.target.value;
        setMappingDetails({ ...mappingDetails, document: updatedDocs });
      }}
    />
  </Grid> */}

  {/* File Upload */}
<Grid item xs={6}>
  <Box display="flex" alignItems="center" gap={1}>
    {/* File Input */}
    <input
      accept="image/*,.pdf,.doc,.docx"
      type="file"
      id={`file-upload-${index}`}
      style={{ display: "none" }}
      onChange={(e) => {
        const file = e.target.files[0];
        if (file) {
          const reader = new FileReader();
          reader.onload = () => {
            setMappingDetails((prev) => {
              const updatedDocs = [...prev.document];
              // Ensure the object exists at this index
              if (!updatedDocs[index]) updatedDocs[index] = {};
              updatedDocs[index] = {
                ...updatedDocs[index],
                imageMeta: file.name,
                image: reader.result.split(",")[1], // base64
              };
              return { ...prev, document: updatedDocs };
            });
          };
          reader.readAsDataURL(file);
        }
      }}
    />

    {/* Choose File Button */}
    <label htmlFor={`file-upload-${index}`}>
      <MDButton
        component="span"
        variant="outlined"
        sx={{
          textTransform: "none",
          color: "#1e6a91",
          borderColor: "#1e6a91",
          height: "40px",
          "&:hover": { backgroundColor: "#e3f2fd" },
        }}
      >
        Choose File
      </MDButton>
    </label>

    {/* File name link */}
    {mappingDetails.document[index]?.imageMeta && (
      <Typography
        sx={{
          color: "#1e6a91",
          cursor: "pointer",
          textDecoration: "underline",
          fontSize: "13px",
          flexShrink: 0,
        }}
        onClick={() => {
          const doc = mappingDetails.document[index];
          if (!doc.image) return;

          const ext = doc.imageMeta.split(".").pop().toLowerCase();
          const byteCharacters = atob(doc.image);
          const byteNumbers = new Array(byteCharacters.length);
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          const byteArray = new Uint8Array(byteNumbers);

          let mimeType = "application/octet-stream";
          if (["jpg", "jpeg"].includes(ext)) mimeType = "image/jpeg";
          else if (ext === "png") mimeType = "image/png";
          else if (ext === "gif") mimeType = "image/gif";
          else if (ext === "pdf") mimeType = "application/pdf";
          else if (ext === "doc") mimeType = "application/msword";
          else if (ext === "docx")
            mimeType =
              "application/vnd.openxmlformats-officedocument.wordprocessingml.document";

          const blob = new Blob([byteArray], { type: mimeType });
          const url = URL.createObjectURL(blob);

          if (["jpg", "jpeg", "png", "gif", "pdf"].includes(ext)) {
            const newTab = window.open(url, "_blank");
            if (!newTab) alert("Please allow popups to view the file.");
          } else {
            const a = document.createElement("a");
            a.href = url;
            a.download = doc.imageMeta;
            a.click();
          }

          setTimeout(() => URL.revokeObjectURL(url), 10000);
        }}
      >
        {mappingDetails.document[index].imageMeta}
      </Typography>
    )}

    {/* Delete Icon */}
    {mappingDetails.document[index]?.imageMeta && (
      <IconButton
        size="small"
        color="error"
        onClick={() => {
          setMappingDetails((prev) => {
            const updatedDocs = [...prev.document];
            if (!updatedDocs[index]) updatedDocs[index] = {};
            updatedDocs[index] = {
              ...updatedDocs[index],
              imageMeta: "",
              image: "",
            };
            return { ...prev, document: updatedDocs };
          });
        }}
         sx={{ p: 0 }}
      >
          <DeleteIcon sx={{ fontSize: 18 }} />
      </IconButton>
    )}
  </Box>
</Grid>




  {/* Aadhaar Verification Button */}
  {/* {doc.documentname === "Aadhar Card" && !doc.verified && (
    <Grid item xs={12}>
      <MDButton
        variant="outlined"
        onClick={() => {
          // Simulate Aadhaar verification API / external link
          window.open("https://myaadhaar.uidai.gov.in/", "_blank");

          // Example: set verified = true after successful verification
          const updatedDocs = [...mappingDetails.document];
          updatedDocs[index].verified = true;
          setMappingDetails({ ...mappingDetails, document: updatedDocs });
        }}
        sx={{
          background: "#2e7faeff",
          color: "#fff",
          "&:hover": { background: "#1e6a91" },
          mt: 1,
        }}
      >
        Verify Aadhaar
      </MDButton>
    </Grid>
  )} */}
</Grid> 
))}

  {/* <Grid item xs={12} sx={{ display: "flex", justifyContent: "flex-start", mt: 1 }}> */}
  <MDButton
    variant="outlined"
    onClick={handleAddDocument}
    sx={{
      textTransform: "none",
      color: "#000",
      borderColor: "#000",
      backgroundColor: "transparent",
      height: 40,
        mt: 1,
      "&:hover": {
        backgroundColor: "#f0f0f0",
        borderColor: "#000",
      },
      "&:focus": {
        outline: "none",
      },
    }}
  >
    + Add Another Document
  </MDButton>
{/* </Grid> */}


 
            </Grid>

            {/* Buttons */}
           <MDBox mt={3} display="flex" justifyContent="flex-end">
  <MDButton
    variant="gradient"
    onClick={() => navigate(-1)}
    // type="submit"
    sx={{
      background: "#3949AB !important",
      color: "#fff !important",
      boxShadow: "none !important",
      "&:hover": {
        background: "#3949AB !important",
        boxShadow: "none !important",
      },
      "&:focus": {
        background: "#3949AB !important",
        boxShadow: "none !important",
        outline: "none",
      },
      "&:active": {
        background: "#3949AB !important",
        boxShadow: "none !important",
      },
      mr: 1, // small space between buttons
    }}
  >
    Cancel
  </MDButton>

  <MDButton
    variant="gradient"
    type="submit"
    sx={{
      background: "#3949AB !important",
      color: "#fff !important",
      boxShadow: "none !important",
      "&:hover": {
        background: "#3949AB !important",
        boxShadow: "none !important",
      },
      "&:focus": {
        background: "#3949AB !important",
        boxShadow: "none !important",
        outline: "none",
      },
      "&:active": {
        background: "#3949AB !important",
        boxShadow: "none !important",
      },
    }}
  >
    Submit
  </MDButton>
</MDBox>

          </form>
        </MDBox>
      </Card>
    </DashboardLayout>
  );
}

export default AddHospitalData;
